import React from 'react';
import './App.css';

import Homepage from './Components/Homepage';
import Aboutpage from './Components/Aboutpage';
import Why from './Components/Why';
import Find from './Components/Find';
import Services from './Components/Services';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
    <Router>
    <div>
      
      <Routes>
        <Route path="/" element={<Homepage />} />
        
        <Route path="/Aboutpage" element={<Aboutpage />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Why" element={<Why />} />
        <Route path="/Find" element={<Find />} />
        <Route path="/Contact" element={<Contact />} />
      </Routes>
      <Footer/>
    </div>
  </Router>
  </>
  );
}

export default App;
